import React from 'react';
import { productSkuIds, T_PlanSelector, T_Product, useBBname } from '@sky-tv-group/shared';
import { T_SpeedShowCase } from '../../../../../../types';
import { BBMarketingInfo } from './BBMarketingInfo';
import { LatestTech } from './latestTech';

interface Props {
  product: T_Product;
  content: T_SpeedShowCase;
  plan: T_PlanSelector;
}

const BroadbandContent = ({ product, content, plan }: Props) => {
  let fluidFontSize = 'calc(20px + (30 - 20) * ((100vw - 320px) / (1024-320)))';
  const bbName = useBBname();

  const caption = () => {
    switch (product!.sku) {
      case productSkuIds.broadbandWifi100Boost.primary:
        return (
          <>
            <p className="py-4 md:sky-h5 sky-h5 text-gray-darker">
              If breakneck speed isn’t your priority then check out Sky Broadband’s WiFi 100 plans for unlimited fibre
              and the latest WiFi 6 tech.
            </p>
            <p className="pt-4 md:sky-h5 sky-h5 text-gray-darker">
              Need your WiFi to go further? Our Boost plans include the use of a Sky WiFi Booster. We suggest getting a
              Boost plan if your home is:
            </p>
            <ul className="pb-4 md:sky-h5 sky-h5 text-gray-darker marker:text-gray list-outside list-disc ml-6">
              <li>Over 200m2</li>
              <li>Has two or more levels</li>
              <li>Has two or more lounge rooms</li>
              <li>Has four or more bedrooms</li>
              <li>Has any internal walls made from concrete or steel</li>
            </ul>
            <p className="py-4 md:sky-h5 sky-h5 text-gray-darker">
              One booster should do the trick, but if you find you need more coverage give our friendly Kiwi crew a
              call.
            </p>
          </>
        );
      case productSkuIds.broadbandLightningFastWiFiBoost.primary:
        return (
          <>
            <p className="py-4 md:sky-h5 sky-h5 text-gray-darker">
              Unlimited lightning fast fibre and the latest WiFi 6 tech which is way gruntier than 1-5 (who knew that
              was a thing). This means that when your household is streaming, video calling or gaming, it will handle
              the demand on your WiFi more efficiently. That’s less b…b…buffering and more uninterrupted entertainment
              for the whole family throughout your home.
            </p>
            <p className="pt-4 md:sky-h5 sky-h5 text-gray-darker">
              Need your WiFi to go further? Our Boost plans include the use of a Sky WiFi Booster. We suggest getting a
              Boost plan if your home is:
            </p>
            <ul className="pb-4 md:sky-h5 sky-h5 text-gray-darker marker:text-gray list-outside list-disc ml-6">
              <li>Over 200m2</li>
              <li>Has two or more levels</li>
              <li>Has two or more lounge rooms</li>
              <li>Has four or more bedrooms</li>
              <li>Has any internal walls made from concrete or steel</li>
            </ul>
            <p className="py-4 md:sky-h5 sky-h5 text-gray-darker">
              One booster should do the trick, but if you find you need more coverage give our friendly Kiwi crew a
              call.
            </p>
          </>
        );
      case productSkuIds.broadbandLightningFastWiFi.primary:
        return (
          <p className="py-4 md:sky-h5 sky-h5 text-gray-darker">
            Unlimited lightning fast fibre and the latest WiFi 6 tech which is way gruntier than 1-5 (who knew that was
            a thing). This means that when your household is streaming, video calling or gaming, it will handle the
            demand on your WiFi more efficiently. That’s less b…b…buffering and more uninterrupted entertainment for the
            whole family throughout your home.
          </p>
        );

      /* Fibre Starter . */
      case productSkuIds.broadbandEssnFibre.primary:
      case productSkuIds.broadbandEssnFibBoost.primary:
        return (
          <p className="py-4 md:sky-h5 sky-h5 text-gray-darker">
            Ideal for emails, online banking, social media, streaming movies, making video calls with ease and browsing
            the web.
          </p>
        );

      default:
        return (
          <p className="py-4 md:sky-h5 sky-h5 text-gray-darker">
            {`If breakneck speed isn’t your priority then check out Sky Broadband’s ${bbName.broadbandWifi100.label} plans for unlimited fibre
            and the latest WiFi 6 tech.`}
          </p>
        );
    }
  };

  return (
    <div className="flex flex-col container pt-14 mx-auto">
      <div className="px-12 md:px-0">
        <p className="md:sky-h3 sky-h3">{plan.header.title}</p>
        {caption()}
        <div className="flex flex-wrap my-4 bg-primary-mid-night text-primary-white">
          <div className="w-full md:w-1/3 flex flex-col items-center p-4 ">
            <div className="w-10 h-10 md:w-12 md:h-12">
              <img src="/images/arrow.svg" alt="arrow" />
            </div>
            <p className="xl:hidden text-bborange sky-h4 font-skyBold md:sky-h3" style={{ fontSize: fluidFontSize }}>
              {content.download.title}
            </p>
            <p className="hidden xl:flex text-bborange sky-h4 font-skyBold md:sky-h3" style={{ fontSize: '30px' }}>
              {content.download.title}
            </p>
            <p className="xl:hidden sky-h4 font-skyBold md:sky-h3 text-center" style={{ fontSize: fluidFontSize }}>
              {content.download.desc}
            </p>
            <p className="hidden xl:flex sky-h4 font-skyBold md:sky-h3 text-center" style={{ fontSize: '30px' }}>
              {content.download.desc}
            </p>
            {/* <p className="sky-h6 pt-4 md:pt-8">
                up to <strong>{content.download.speed}</strong>
              </p> */}
          </div>
          <div
            className="w-full md:w-1/3 bg-cover bg-center min-h-200"
            style={{
              backgroundImage: `url(${plan.exploreImg})`,
            }}></div>
          <div className="w-full md:w-1/3 flex flex-col items-center p-4">
            <div className="w-10 h-10 md:w-12 md:h-12">
              <img src="/images/arrow.svg" alt="arrow" />
            </div>
            <p className="xl:hidden text-bborange sky-h4 font-skyBold md:sky-h3" style={{ fontSize: fluidFontSize }}>
              {content.upload.title}
            </p>
            <p className="hidden xl:flex text-bborange sky-h4 font-skyBold md:sky-h3" style={{ fontSize: '30px' }}>
              {content.upload.title}
            </p>
            <p className="xl:hidden sky-h4 font-skyBold md:sky-h3 text-center" style={{ fontSize: fluidFontSize }}>
              {content.upload.desc}
            </p>
            <p className="hidden xl:flex sky-h4 font-skyBold md:sky-h3 text-center" style={{ fontSize: '30px' }}>
              {content.upload.desc}
            </p>
            {/* <p className="sky-h6 pt-4 md:pt-8">
                up to <strong>{content.upload.speed}</strong>
              </p> */}
          </div>
        </div>

        <p className="text-link-xxs mt-5">
          Fibre Pro and Fibre Everyday speeds shown are based on our network provider's average peak time speeds shown
          in the Commerce Commission MBNZ Report 27, April 2026. Your speeds may vary especially over WiFi. Factors
          that can affect your speed include the time of day, where you live, the location and quality of your router
          and devices and the number of devices being used.
          <a
            className="text-primary-day-light underline"
            href="https://help.sky.co.nz/s/article/How-fast-is-it-really"
            target="_blank"
            rel="noopener noreferrer">
            &nbsp;Learn more.
          </a>
        </p>

        <BBMarketingInfo />
        <LatestTech />

        <div className="m-10"></div>
      </div>
    </div>
  );
};

export default BroadbandContent;
